import React from 'react';
import { useSelector } from 'react-redux';

import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Grid from '@material-ui/core/Grid';

export default function SelectMaterialType(props) {

    const materialState = useSelector(state => state.material)

    const materialTypesFetched = !!materialState.types.length

    return (
        <Select
            className={props.className}
            value={props.value || 0}
            onChange={props.onChange}
            disabled={!materialTypesFetched}
        >            
            <MenuItem value={0}>
                <Grid item container justify="space-between">
                    <em>Todos os tipos de material</em>
                </Grid>
            </MenuItem>

            {materialTypesFetched && materialState.types.map((material, index) => (
                <MenuItem key={index} value={material['id-tipo-material']}>
                    {material.descricao}
                </MenuItem>
            ))}
        </Select>
    );
}